<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div class="flex items-center">
      <div class="dropdown-heading-icon flex items-center justify-center">
        <mat-icon svgIcon="mat:person"></mat-icon>
      </div>
      <div class="dropdown-heading">{{ userName }}</div>
    </div>
  </div>

  <div class="dropdown-footer flex items-center justify-center gap-2">
    <a (click)="openChangePassword()" mat-button>
      <mat-icon svgIcon="mat:lock_reset" class="icon-sm mr-2"></mat-icon>
      Cambiar contraseña
    </a>
    <a (click)="logout()" color="primary" mat-button>
      <mat-icon svgIcon="mat:logout" class="icon-sm mr-2"></mat-icon>
      Cerrar Sesión
    </a>
  </div>
</div>
